import { Card } from "@/components/ui/Card";

/**
 * Shown when the app is opened outside Telegram (no initData).
 * Tells the user how to bind their account.
 */
export function SplashView() {
  return (
    <main className="mx-auto flex min-h-screen max-w-app flex-col items-center justify-center gap-6 p-6 text-center">
      <h1 className="text-2xl font-semibold">prosto.task</h1>
      <Card className="space-y-4">
        <p>
          Это Mini App. Открой бота в Telegram и нажми кнопку «Открыть» — мы тебя автоматически
          узнаем по Telegram-аккаунту.
        </p>
        <p className="text-sm text-hint">
          Логина и пароля нет. Если ты не в allowlist — попроси админа добавить твой Telegram ID.
        </p>
      </Card>
    </main>
  );
}
